/* global cURL */
export class Accessibility {
  #htmlElement;

  constructor() {
    this.#htmlElement = document.documentElement;
    this.#bindEvents();
  }

  /**
   * Toggle high contrast.
   */
  #handleHighContrastToggle = async e => {
    e.preventDefault();
    const url = new URL(`${cURL}mwork/ajax/change-accessibility-property.jsp`);
    const params = {
      type: 'high-contrast'
    };
    Object.entries(params).forEach(([k, v]) => url.searchParams.append(k, v));
    try {
      const response = await fetch(url, { method: 'POST' });
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! Status: ${response.status}, Message: ${errorText}`);
      }
      const data = await response.json();
      const newHighContrast = parseInt(data, 10);
      if (isNaN(newHighContrast))
        throw new Error('Received data is not a valid number for high contrast.');

      if (!!newHighContrast) this.#htmlElement.classList.add('high-contrast');
      else this.#htmlElement.classList.remove('high-contrast');
    }
    catch (error) {
      console.error('Failed to change accessibility property (high contrast)', error);
    }
  };

  #bindEvents() {
    document.querySelectorAll('[data-high-contrast]').forEach(el => {
      el.addEventListener('click', this.#handleHighContrastToggle);
    });
  }
}
